import { render, staticRenderFns } from "./StorySection.vue?vue&type=template&id=c118db8e&scoped=true"
import script from "./StorySection.vue?vue&type=script&lang=js"
export * from "./StorySection.vue?vue&type=script&lang=js"
import style0 from "./StorySection.vue?vue&type=style&index=0&id=c118db8e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c118db8e",
  null
  
)

export default component.exports